import axios, { AxiosResponse } from 'axios';

export const getTaxOrg = (): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/tax-org/search', {
        params: {
            levels: 3
        }
    });
};

export const getKnp = (): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/dictionary/knp/filter-dictionary', {});
};

export const getKbk = (): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/filter-dictionary', {}, {
        params: {
            dictionaryCode: 'tax_classification',
            size: 1000
        }
    });
};

export const getMsuList = (data): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/filter-dictionary', data, {
        params: {
            dictionaryCode: 'ref_msu',
            size: 1000
        }
    });
};
